module.exports = __webpack_public_path__ + "static/img/9.ebcc6a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-cn/9.jpg
// module id = GZJF
// module chunks = 1